import script from "./ShapeUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShapeUpload.vue?vue&type=script&setup=true&lang=ts"

import "./ShapeUpload.vue?vue&type=style&index=0&id=1180d9d3&scoepd=true&lang=scss"

const __exports__ = script;

export default __exports__